import React, { useCallback } from 'react';
import Authenticated from '@/Layouts/Authenticated';
import { Head, Link } from '@inertiajs/inertia-react';
import { EditSchedule } from '@/Components/EditSchedule';
import { OrdersList } from '../Components/OrdersList';

export default function ShowSchedule({
    store,
    branchOffice,
    date,
    time,
    formatedDateTime,
    schedule,
    invoiceRequested,
    isSuperAdmin,
    ...props}) {

    const Header = useCallback(() => {
        return (
            <div className='flex justify-between gap-2'>
                <h2 className="font-semibold text-lg sm:text-xl text-gray-800 leading-tight">
                    {formatedDateTime}
                </h2>
                <Link href={route('schedule.index', {
                    office:branchOffice.slug,
                    date: date
                    })}>
                    ← Volver
                </Link>
            </div>
        )
    }, [formatedDateTime, branchOffice, date])

    //console.log(props.auth.user.roles.some(role => role.name === 'admin' || role.name === 'super_admin'))

    return (
        <Authenticated
            store={store}
            auth={props.auth}
            errors={props.errors}
            header={<Header />}
            branchOffice={branchOffice}
        >
            <Head title="Dashboard" />

            <div className="py-12 max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto flex flex-col gap-10">
                <EditSchedule office={branchOffice} store={store} schedule={schedule} canEdit={props.auth.user.roles.some(role => role.name === 'admin' || role.name === 'super_admin')} allowDeletion={props.allowDeletion}/>
                <OrdersList isSuperAdmin={isSuperAdmin} orders={props.orders} store={store} invoiceRequested={invoiceRequested}/>
            </div>


        </Authenticated>
    );
}
